import EditEventtypePageComponent from "./components/EditEventtypePageComponent";

import axios from "axios";

const fetchEventtype = async (eventtypeId) => {
    const { data } = await axios.get(`/api/eventtypes/${eventtypeId}`);
    return data;
}


const updateEventtypeApiRequest = async (eventtypeId, formInputs) => {
    const { data } = await axios.put(`/api/eventtypes/${eventtypeId}`, { ...formInputs });
    return data;
}


const AdminEditEventtypePage = () => {
  
  return <EditEventtypePageComponent updateEventtypeApiRequest={updateEventtypeApiRequest} fetchEventtype={fetchEventtype} />;
};


export default AdminEditEventtypePage;
